var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('header',[_c('img',{staticClass:"header_img",attrs:{"src":_vm.ui.head,"alt":"头图"}})]),_c('div',{staticClass:"detail_img"},[_c('img',{ref:"tailImage",staticClass:"detail_img",attrs:{"src":_vm.ui.tail,"alt":""}})]),_c('div',[(_vm.ui.is_copyright)?_c('copyright',{staticStyle:{"padding-bottom":"0"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }